'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleTooltip = require('reactackle-tooltip');

var _reactackleCore = require('reactackle-core');

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

(0, _reactackleCore.registerDefaultComponentTheme)('text', _styles.componentTheme);

/**
 * Combined with tooltip
 */
var propTypes = {
  /**
   * Text of the component
   */
  text: _propTypes2.default.string,
  /**
   * Text display type
   */
  display: _propTypes2.default.oneOf(['default', 'caption', 'body', 'bodyStrong', 'subheading', 'title', 'headline', 'display1', 'display2', 'display3', 'display4']),
  /**
   * Tooltip text
   */
  tooltipText: _propTypes2.default.string,
  /**
   * @ignore
   */
  toggleTooltip: _propTypes2.default.func,
  /**
   * @ignore
   */
  showTooltip: _propTypes2.default.func,
  /**
   * @ignore
   */
  hideTooltip: _propTypes2.default.func
};

var defaultProps = {
  text: '',
  display: 'default',
  tooltipText: '',
  toggleTooltip: _reactackleCore.noop,
  showTooltip: _reactackleCore.noop,
  hideTooltip: _reactackleCore.noop
};

var TextComponent = function TextComponent(_ref) {
  var text = _ref.text,
      display = _ref.display,
      tooltipText = _ref.tooltipText,
      children = _ref.children,
      toggleTooltip = _ref.toggleTooltip,
      showTooltip = _ref.showTooltip,
      hideTooltip = _ref.hideTooltip,
      props = _objectWithoutProperties(_ref, ['text', 'display', 'tooltipText', 'children', 'toggleTooltip', 'showTooltip', 'hideTooltip']);

  var tooltipElement = tooltipText && _react2.default.createElement(
    props.Tooltip,
    null,
    tooltipText
  );

  var wrapperProps = {
    onClick: toggleTooltip,
    onFocus: showTooltip,
    onBlur: hideTooltip,
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip
  };

  return _react2.default.createElement(
    _styles.TextStyled,
    _extends({}, wrapperProps, { display: display }),
    text || children,
    tooltipElement
  );
};

TextComponent.propTypes = propTypes;
TextComponent.defaultProps = defaultProps;
TextComponent.displayName = 'Text';

exports.default = (0, _reactackleTooltip.withTooltip)(TextComponent, true);


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-text/dist/Text.js
// module id = 858
// module chunks = 0